import React from 'react'
import { profile } from '../../constants';

const FooterBottom = () => {
  return (
    <div className="w-full py-10">
      <p className="text-center text-gray-500 text-base">
        © {new Date().getFullYear()}. All rights reserved by {profile.name}
      </p>
    </div>
  );
}

export default FooterBottom
